import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
============
== POTREE ==
============

http://potree.org

Copyright (c) 2011-2020, Markus Schütz
All rights reserved.

    Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.
2. Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

    The views and conclusions contained in the software and documentation are those
of the authors and should not be interpreted as representing official policies,
    either expressed or implied, of the FreeBSD Project.
 */
import { PointAttribute, PointAttributeTypes } from "../Core/Potree2PointAttributes";
import { decompress } from 'brotli-compress';
var typedArrayMapping = {
  int8: Int8Array,
  int16: Int16Array,
  int32: Int32Array,
  int64: Float64Array,
  uint8: Uint8Array,
  uint16: Uint16Array,
  uint32: Uint32Array,
  uint64: Float64Array,
  "float": Float32Array,
  "double": Float64Array
};

function dealign24b(mortoncode) {
  // see https://stackoverflow.com/questions/45694690/how-i-can-remove-all-odds-bits-in-c
  // input alignment of desired bits
  // ..a..b..c..d..e..f..g..h..i..j..k..l..m..n..o..p
  var x = mortoncode; //          ..a..b..c..d..e..f..g..h..i..j..k..l..m..n..o..p                     ..a..b..c..d..e..f..g..h..i..j..k..l..m..n..o..p
  //          ..a.....c.....e.....g.....i.....k.....m.....o...                     .....b.....d.....f.....h.....j.....l.....n.....p
  //          ....a.....c.....e.....g.....i.....k.....m.....o.                     .....b.....d.....f.....h.....j.....l.....n.....p

  x = (x & 2130440) >> 2 | (x & 266305) >> 0; //          ....ab....cd....ef....gh....ij....kl....mn....op                     ....ab....cd....ef....gh....ij....kl....mn....op
  //          ....ab..........ef..........ij..........mn......                     ..........cd..........gh..........kl..........op
  //          ........ab..........ef..........ij..........mn..                     ..........cd..........gh..........kl..........op

  x = (x & 786624) >> 4 | (x & 12291) >> 0; //          ........abcd........efgh........ijkl........mnop                     ........abcd........efgh........ijkl........mnop
  //          ........abcd....................ijkl............                     ....................efgh....................mnop
  //          ................abcd....................ijkl....                     ....................efgh....................mnop

  x = (x & 61440) >> 8 | (x & 15) >> 0; //          ................abcdefgh................ijklmnop                     ................abcdefgh................ijklmnop
  //          ................abcdefgh........................                     ........................................ijklmnop
  //          ................................abcdefgh........                     ........................................ijklmnop

  x = (x & 0) >> 16 | (x & 255) >> 0; // sucessfully realigned!
  // ................................abcdefghijklmnop

  return x;
}

onmessage = /*#__PURE__*/function () {
  var _processMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
    var _event$data, pointAttributes, scale, name, min, size, offset, numPoints, buffer, view, attributeBuffers, gridSize, grid, toIndex, numOccupiedCells, byteOffset, _iterator, _step, pointAttribute, _buff, positions, _j, mc_0, mc_1, mc_2, mc_3, X, Y, Z, x, y, z, index, count, _buff2, colors, _j2, _mc_, _mc_2, r, g, b, _buff3, _f, TypedArray, preciseBuffer, _offset2, _scale2, getterMap, _getter, _pointAttribute$range, amin, amax, _j3, _value, occupancy, buff, indices, i, vectors, _iterator2, _step2, vector, _name, attributes, numVectorElements, _buffer, f32, iElement, _iterator3, _step3, sourceName, sourceBuffer, _offset, _scale, _view, getter, j, value, vecAttribute, message, transferables;

    return _regeneratorRuntime.wrap(function (_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _event$data = event.data, pointAttributes = _event$data.pointAttributes, scale = _event$data.scale, name = _event$data.name, min = _event$data.min, size = _event$data.size, offset = _event$data.offset, numPoints = _event$data.numPoints;

            if (!(numPoints === 0)) {
              _context.next = 5;
              break;
            }

            buffer = {
              buffer: new ArrayBuffer(0)
            };
            _context.next = 15;
            break;

          case 5:
            _context.prev = 5;
            _context.next = 8;
            return decompress(new Int8Array(event.data.buffer));

          case 8:
            buffer = _context.sent;
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            buffer = {
              buffer: new ArrayBuffer(numPoints * (pointAttributes.byteSize + 12))
            };
            console.error("problem with node ".concat(name, ": "), _context.t0);

          case 15:
            view = new DataView(buffer.buffer);
            attributeBuffers = {};
            gridSize = 32;
            grid = new Uint32Array(Math.pow(gridSize, 3));

            toIndex = function (x, y, z) {
              // min is already subtracted
              var dx = gridSize * x / size.x;
              var dy = gridSize * y / size.y;
              var dz = gridSize * z / size.z;
              var ix = Math.min(parseInt(dx, 10), gridSize - 1);
              var iy = Math.min(parseInt(dy, 10), gridSize - 1);
              var iz = Math.min(parseInt(dz, 10), gridSize - 1);
              var index = ix + iy * gridSize + iz * gridSize * gridSize;
              return index;
            };

            numOccupiedCells = 0;
            byteOffset = 0;
            _iterator = _createForOfIteratorHelper(pointAttributes.attributes);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                pointAttribute = _step.value;

                if (['POSITION_CARTESIAN', 'position'].includes(pointAttribute.name)) {
                  _buff = new ArrayBuffer(numPoints * 4 * 3);
                  positions = new Float32Array(_buff);

                  for (_j = 0; _j < numPoints; _j++) {
                    mc_0 = view.getUint32(byteOffset + 4, true);
                    mc_1 = view.getUint32(byteOffset + 0, true);
                    mc_2 = view.getUint32(byteOffset + 12, true);
                    mc_3 = view.getUint32(byteOffset + 8, true);
                    byteOffset += 16;
                    X = dealign24b((mc_3 & 0x00FFFFFF) >>> 0) | dealign24b((mc_3 >>> 24 | mc_2 << 8) >>> 0) << 8;
                    Y = dealign24b((mc_3 & 0x00FFFFFF) >>> 1) | dealign24b((mc_3 >>> 24 | mc_2 << 8) >>> 1) << 8;
                    Z = dealign24b((mc_3 & 0x00FFFFFF) >>> 2) | dealign24b((mc_3 >>> 24 | mc_2 << 8) >>> 2) << 8;

                    if (mc_1 != 0 || mc_2 != 0) {
                      X = X | dealign24b((mc_1 & 0x00FFFFFF) >>> 0) << 16 | dealign24b((mc_1 >>> 24 | mc_0 << 8) >>> 0) << 24;
                      Y = Y | dealign24b((mc_1 & 0x00FFFFFF) >>> 1) << 16 | dealign24b((mc_1 >>> 24 | mc_0 << 8) >>> 1) << 24;
                      Z = Z | dealign24b((mc_1 & 0x00FFFFFF) >>> 2) << 16 | dealign24b((mc_1 >>> 24 | mc_0 << 8) >>> 2) << 24;
                    }

                    x = parseInt(X, 10) * scale[0] + offset[0] - min.x;
                    y = parseInt(Y, 10) * scale[1] + offset[1] - min.y;
                    z = parseInt(Z, 10) * scale[2] + offset[2] - min.z;
                    index = toIndex(x, y, z);
                    count = grid[index]++;

                    if (count === 0) {
                      numOccupiedCells++;
                    }

                    positions[3 * _j + 0] = x;
                    positions[3 * _j + 1] = y;
                    positions[3 * _j + 2] = z;
                  }

                  attributeBuffers[pointAttribute.name] = {
                    buffer: _buff,
                    attribute: pointAttribute
                  };
                } else if (['RGBA', 'rgba'].includes(pointAttribute.name)) {
                  _buff2 = new ArrayBuffer(numPoints * 4);
                  colors = new Uint8Array(_buff2);

                  for (_j2 = 0; _j2 < numPoints; _j2++) {
                    _mc_ = view.getUint32(byteOffset + 4, true);
                    _mc_2 = view.getUint32(byteOffset + 0, true);
                    byteOffset += 8;
                    r = dealign24b((_mc_2 & 0x00FFFFFF) >>> 0) | dealign24b((_mc_2 >>> 24 | _mc_ << 8) >>> 0) << 8;
                    g = dealign24b((_mc_2 & 0x00FFFFFF) >>> 1) | dealign24b((_mc_2 >>> 24 | _mc_ << 8) >>> 1) << 8;
                    b = dealign24b((_mc_2 & 0x00FFFFFF) >>> 2) | dealign24b((_mc_2 >>> 24 | _mc_ << 8) >>> 2) << 8;
                    colors[4 * _j2 + 0] = r > 255 ? r / 256 : r;
                    colors[4 * _j2 + 1] = g > 255 ? g / 256 : g;
                    colors[4 * _j2 + 2] = b > 255 ? b / 256 : b;
                  }

                  attributeBuffers[pointAttribute.name] = {
                    buffer: _buff2,
                    attribute: pointAttribute
                  };
                } else {
                  _buff3 = new ArrayBuffer(numPoints * 4);
                  _f = new Float32Array(_buff3);
                  TypedArray = typedArrayMapping[pointAttribute.type.name];
                  preciseBuffer = new TypedArray(numPoints);
                  _offset2 = 0, _scale2 = 1;
                  getterMap = {
                    int8: view.getInt8,
                    int16: view.getInt16,
                    int32: view.getInt32,
                    uint8: view.getUint8,
                    uint16: view.getUint16,
                    uint32: view.getUint32,
                    "float": view.getFloat32,
                    "double": view.getFloat64
                  };
                  _getter = getterMap[pointAttribute.type.name].bind(view); // compute offset and scale to pack larger types into 32 bit floats

                  if (pointAttribute.type.size > 4) {
                    _pointAttribute$range = _slicedToArray(pointAttribute.range, 2), amin = _pointAttribute$range[0], amax = _pointAttribute$range[1];
                    _offset2 = amin;
                    _scale2 = 1 / (amax - amin);
                  }

                  for (_j3 = 0; _j3 < numPoints; _j3++) {
                    _value = _getter(byteOffset, true);
                    byteOffset += pointAttribute.byteSize;
                    _f[_j3] = (_value - _offset2) * _scale2;
                    preciseBuffer[_j3] = _value;
                  }

                  attributeBuffers[pointAttribute.name] = {
                    buffer: _buff3,
                    preciseBuffer: preciseBuffer,
                    attribute: pointAttribute,
                    offset: _offset2,
                    scale: _scale2
                  };
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            occupancy = parseInt(numPoints / numOccupiedCells, 10);
            // add indices
            buff = new ArrayBuffer(numPoints * 4);
            indices = new Uint32Array(buff);

            for (i = 0; i < numPoints; i++) {
              indices[i] = i;
            }

            attributeBuffers.INDICES = {
              buffer: buff,
              attribute: PointAttribute.INDICES
            };
            // handle attribute vectors
            vectors = pointAttributes.vectors;
            _iterator2 = _createForOfIteratorHelper(vectors);

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                vector = _step2.value;
                _name = vector.name, attributes = vector.attributes;
                numVectorElements = attributes.length;
                _buffer = new ArrayBuffer(numVectorElements * numPoints * 4);
                f32 = new Float32Array(_buffer);
                iElement = 0;
                _iterator3 = _createForOfIteratorHelper(attributes);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    sourceName = _step3.value;
                    sourceBuffer = attributeBuffers[sourceName];
                    _offset = sourceBuffer.offset, _scale = sourceBuffer.scale;
                    _view = new DataView(sourceBuffer.buffer);
                    getter = _view.getFloat32.bind(_view);

                    for (j = 0; j < numPoints; j++) {
                      value = getter(j * 4, true);
                      f32[j * numVectorElements + iElement] = value / _scale + _offset;
                    }

                    iElement++;
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                vecAttribute = new PointAttribute(_name, PointAttributeTypes.DATA_TYPE_FLOAT, 3);
                attributeBuffers[_name] = {
                  buffer: _buffer,
                  attribute: vecAttribute
                };
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            message = {
              buffer: buffer,
              attributeBuffers: attributeBuffers,
              density: occupancy
            };
            transferables = [];
            Object.keys(message.attributeBuffers).forEach(function (property) {
              transferables.push(message.attributeBuffers[property].buffer);
            });
            postMessage(message, transferables);

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11]]);
  }));

  function processMessage() {
    return _processMessage.apply(this, arguments);
  }

  return processMessage;
}();